import { LOCALES_LANG_INFO, SWEDISH_LOCALES } from '@packages/locale/constants/lang.ts'
import type { Locale, LocaleLangInfo, Market } from '@packages/locale/types/locales.ts'

export const localeToLangInfo = (locale: Locale | Market): LocaleLangInfo => {
  const langLocale = SWEDISH_LOCALES.includes(locale) ? 'sv' : locale

  const localeLangInfo = LOCALES_LANG_INFO[langLocale]

  if (!localeLangInfo) {
    throw new Error('Unknown locale: ' + locale)
  }

  return localeLangInfo
}

export const localeToLang = (locale: Locale | Market) => localeToLangInfo(locale).lang
